module.exports = __webpack_public_path__ + "static/meister-34cd8ad5988a0deed35aac55afdbc542.png";